export { default as useLicense } from './use-license';
export { default as useSettings } from './use-settings';
